import { getCurrentDate } from "../../../../utils/dateFormat";

// Read from/to dates from localStorage dateForPDF.
export const getPdfDateRange = () => {
  const dateForPDF = localStorage.getItem("dateForPDF");
  const dateToSet = JSON.parse(dateForPDF);
  const defaultDate = getCurrentDate();

  const fromDate =
    dateToSet != null && dateToSet.fromdate ? dateToSet.fromdate : defaultDate;
  const toDate =
    dateToSet != null && dateToSet.todate ? dateToSet.todate : defaultDate;

  return {
    fromDate,
    toDate,
    dateLabel: fromDate + " To " + toDate,
  };
};

// Pull category / uom / summary lists from API dtoLoadSheet.
export const getSkuPdfLists = (billList) => {
  const dataToSet = billList.dtoLoadSheet || {};
  return {
    categoryWithProducts:
      dataToSet.categoryWithProducts != null
        ? dataToSet.categoryWithProducts
        : [],
    uomList: dataToSet.uoms != null ? dataToSet.uoms : [],
    orderSummaries:
      dataToSet.orderSummaries != null ? dataToSet.orderSummaries : [],
  };
};

export const createEmptyTotals = (uomList) => {
  const totals = { all: 0 };
  (uomList || []).forEach((uom) => {
    totals[uom.id] = 0;
  });
  return totals;
};

// Match order summary by productId + uomId.
export const findOrderSummary = (orderSummaries, productId, uomId) =>
  (orderSummaries || []).find(
    (row) => row.productId === productId && row.uomId === uomId
  );

// Category totals using feature-specific qty helpers (no product row cloning).
export const getCategoryTotals = ({
  categoryData,
  uomList,
  orderSummaries,
  getUomQty,
  getProductAllQty,
}) => {
  const categoryTotal = createEmptyTotals(uomList);
  const products =
    categoryData.products != null ? categoryData.products : [];

  products.forEach((product) => {
    (uomList || []).forEach((uom) => {
      const summary = findOrderSummary(orderSummaries, product.id, uom.id);
      categoryTotal[uom.id] += getUomQty(summary);
    });
    categoryTotal.all += getProductAllQty(product, uomList, orderSummaries);
  });

  return categoryTotal;
};

// Final totals across all categories.
export const getFinalTotals = ({
  categoryWithProducts,
  uomList,
  orderSummaries,
  getUomQty,
  getProductAllQty,
}) => {
  const finalTotal = createEmptyTotals(uomList);

  (categoryWithProducts || []).forEach((categoryData) => {
    const categoryTotal = getCategoryTotals({
      categoryData,
      uomList,
      orderSummaries,
      getUomQty,
      getProductAllQty,
    });
    (uomList || []).forEach((uom) => {
      finalTotal[uom.id] += categoryTotal[uom.id];
    });
    finalTotal.all += categoryTotal.all;
  });

  return finalTotal;
};

// Blank cell when qty is 0.
export const displayQty = (qty) => (qty != 0 ? qty : "");

export const displayAmount = (amt) => (amt ? amt.toFixed(2) : "-");
